<template>
  <PrmButton
    v-if="disabled"
    v-tooltip="label"
    size="small"
    text
    disabled
    type="button"
    severity="secondary"
    class="navbar-icon"
  >
    <template #icon>
      <i
        v-if="isIconClass"
        :class="icon"
      />
      <component
        :is="icon"
        v-else
        class="navbar-icon__image"
      />
    </template>
  </PrmButton>
  <router-link
    v-else
    v-slot="{
      href, navigate, isActive,
    }"
    :to="routeTo"
    custom
  >
    <a
      :href="href"
      :target="openInNewTab ? '_blank' : undefined"
      :rel="openInNewTab ? 'noopener noreferrer' : undefined"
      @click="navigate"
    >
      <PrmButton
        v-tooltip="label"
        size="small"
        text
        type="button"
        :severity="isActive
          ? 'primary'
          : 'secondary'"
        :class="{
          'navbar-icon': !isActive,
        }"
      >
        <template #icon>
          <i
            v-if="isIconClass"
            :class="icon"
          />
          <component
            :is="icon"
            v-else
            class="navbar-icon__image"
          />
        </template>
      </PrmButton>
    </a>
  </router-link>
</template>

<script setup lang="ts">
import PrmButton from '@NitrexGroup/primevue/button';
import {
  FunctionalComponent, SVGAttributes,
  computed,
} from 'vue';
import {
  RouteLocationRaw,
} from 'vue-router';

const props = defineProps<{
  label: string,
  routeTo: RouteLocationRaw,
  icon: FunctionalComponent<SVGAttributes, any, any, any> | string,
  disabled?: boolean,
  openInNewTab?: boolean,
}>();

const isIconClass = computed(() => {
  return typeof props.icon === 'string';
});
</script>

<style scoped lang="scss">
.navbar-icon {
  color: var(--color-224) !important;
}

.navbar-icon__image {
    min-width: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
</style>
